import { HttpErrorResponse } from "@angular/common/http";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  Output,
} from "@angular/core";
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import {
  ContractPeriod,
  PalliativeVisitCodes,
  PalliativeVisitCodesDetail,
} from "components/payers/rates-payer/models";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "ionic-angular";
import moment from "moment";
import { PayersService } from "../../../../providers/payers-service/payers.service";
import { NgbCustomParserFormatter } from "../../../common/date-picker/ngb-custom-parser-formatter";

@Component({
  selector: "billing-codes-palliative-visits",
  templateUrl: "./palliative-visits.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BillingCodesPalliativeVisits),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BillingCodesPalliativeVisits),
      multi: true,
    },
    { provide: NgbDateParserFormatter, useClass: NgbCustomParserFormatter },
  ],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class BillingCodesPalliativeVisits implements OnDestroy {
  contractPeriodsOptions: ContractPeriod[];
  _saveEnabled: boolean = false;
  validForm: boolean = true;
  dateFormat: string = "YYYY-MM-DD";
  dateUIFormat: string = "MM/DD/YYYY";
  currentContractPeriod: any;

  @Input() currentPayerType: any;
  @Input() currentPayer: any;
  @Output() onCanceled = new EventEmitter<any>();
  @Output() setCheckMark = new EventEmitter<any>();

  showRatesSection: boolean = false;

  showPalliativeHomeVisitCodes: boolean = false;
  showPalliativeNursingHomeVisitCodes: boolean = false;
  showPalliativeHospitalPatientVisitCodes: boolean = false;
  showPalliativeOtherBillingCodes: boolean = false;

  previousContractPeriod: any;

  hasUnsavedChanges: boolean = false;

  palliativeHomeVisitCodesSetup: any = [
    {
      Service: "99341",
      Description: "Home New Patient Visit Basic",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99342",
      Description: "Home New Patient Visit Low",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99344",
      Description: "Home New Patient Visit Mod Comp",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99345",
      Description: "Home New Patient Visit High",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99347",
      Description: "Home Est Patient Visit Basic",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99348",
      Description: "Home Est Patient Visit Low",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99349",
      Description: "Home Est Patient Visit Moderate",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99350",
      Description: "Home Est Patient Visit High",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
  ];

  palliativeNursingHomeVisitCodesSetup: any = [
    {
      Service: "99304",
      Description: "Nursing Home New Patient Visit Low",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99305",
      Description: "Nursing Home New Patient Visit Moderate",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99306",
      Description: "Nursing Home New Patient Visit High",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99307",
      Description: "Nursing Home Est Patient Low",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99308",
      Description: "Nursing Home Est Patient Moderate",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99309",
      Description: "Nursing Home Est Patient Medium",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99310",
      Description: "Nursing Home Est Patient High",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
  ];

  palliativeHospitalPatientVisitCodesSetup: any = [
    {
      Service: "99221",
      Description: "Initial Hospital Care",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99222",
      Description: "Initial Hospital Care",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99223",
      Description: "Initial Hospital Care",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99231",
      Description: "Subsequent Hospital Care",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99232",
      Description: "Subsequent Hospital Care",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99233",
      Description: "Subsequent Hospital Care",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "98016",
      Description: "Brief Patient Check In/ Phone Call 5-10 Min",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
  ];

  palliativeOtherBillingCodesSetup: any = [
    {
      Service: "99497",
      Description: "Advanced Care Planning 30 Min",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99498",
      Description: "Advanced Care Planning Additional 30 min",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "G2212",
      Description: "Prolonged Outpt/office visit",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "G0316",
      Description: "Prolonged Inpatient 15 min",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "G0317",
      Description: "Prolonged Nursing Facility 15 min",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "G0318",
      Description: "Prolonged Home/Residence 15 min",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99406",
      Description: "Smoking Cessation 3-10 min",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99407",
      Description: "Smoking Cessation > 10 min",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99202",
      Description: "Office or Outpatient Visit, New Patient (5-10 Minutes)",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99215",
      Description:
        "Office or Outpatient Visit, Established Patient (21-30 Minutes)",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99490",
      Description: "Chronic Care Management 20 Minutes",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99495",
      Description: "Transitional Care 14 Day Discharge",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      Service: "99496",
      Description: "Transitional Care 7 day Discharge",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
  ];

  constructor(
    public modalCtrl: ModalController,
    private payersService: PayersService,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private cdr: ChangeDetectorRef
  ) {
    if (this.currentContractPeriod == null) {
      this.currentContractPeriod = this.emptyContractPeriod();
    }
  }

  onPeriodChanged() {
    this.currentContractPeriod = null;
    this.onContractPeriodClear(null);
    this.getPayerContractPeriods(false);
  }

  ngOnChanges(changes) {
    this.contractPeriodsOptions = [];
    this.currentContractPeriod = this.emptyContractPeriod();
    this._saveEnabled = false;
    this.hasUnsavedChanges = false;
    this.getPayerContractPeriods(true);
    //this.loadOptions();
  }

  ngOnDestroy(): void {
    this.currentContractPeriod = this.emptyContractPeriod();
    this._saveEnabled = false;
    this.hasUnsavedChanges = false;
  }

  emptyContractPeriod() {
    return null;
  }

  loadOptions(): void {
    // if (
    //   this.currentPayer &&
    //   this.currentPayer.payerType &&
    //   this.currentPayer.payerType.toUpperCase() === "MEDICARE"
    // ) {
    //   return;
    // }

    let addNewContractPeriodOption: ContractPeriod = {
      id: 0,
      name: "Add New",
      value: "Add New",
      effectiveDate: "",
      expiredDate: "",
    };
    this.contractPeriodsOptions = [
      addNewContractPeriodOption,
      ...this.contractPeriodsOptions,
    ];
  }

  saveVisitCodes() {
    let payerCodes = this.mapNewPalliativeVisitCode(
      {},
      this.currentContractPeriod.effectiveDate,
      this.currentContractPeriod.expiredDate
    );
    payerCodes = this.mapCodesValuesToSave(payerCodes);
    this.saveNewPayerContractPeriod(payerCodes, "Billing Codes saved.", true);
  }

  mapCodesValuesToSave(palliativeVisitPayerCodes: PalliativeVisitCodes) {
    const forEachMap = (formCode) => {
      let code: PalliativeVisitCodesDetail = {
        service: formCode.Service,
        description: formCode.Description,
        M1: formCode.M1,
        M2: formCode.M2,
        M3: formCode.M3,
        M4: formCode.M4,
        revenueCode: "",
        hcpcsCode: "",
      };
      palliativeVisitPayerCodes.codes[code.service] = code;
    };

    this.palliativeHomeVisitCodesSetup.forEach(forEachMap);
    this.palliativeNursingHomeVisitCodesSetup.forEach(forEachMap);
    this.palliativeHospitalPatientVisitCodesSetup.forEach(forEachMap);
    this.palliativeOtherBillingCodesSetup.forEach(forEachMap);

    return palliativeVisitPayerCodes;
  }

  cancel() {
    this.onCanceled.emit(true);
  }

  checkValidForm() {
    this.validForm = true;
    this.palliativeHomeVisitCodesSetup.forEach((visitCode) => {
      if (visitCode.Error != "") this.validForm = false;
    });
    this.palliativeNursingHomeVisitCodesSetup.forEach((visitCode) => {
      if (visitCode.Error != "") this.validForm = false;
    });
    this.palliativeHospitalPatientVisitCodesSetup.forEach((visitCode) => {
      if (visitCode.Error != "") this.validForm = false;
    });
    this.palliativeOtherBillingCodesSetup.forEach((visitCode) => {
      if (visitCode.Error != "") this.validForm = false;
    });
  }

  setPalliativeHomeVisitCodesSetup(value) {
    this.palliativeHomeVisitCodesSetup = value;
    this.checkValidForm();
    this.markDirtyAndUpdateSaveEnabled();
  }

  setPalliativeNursingHomeVisitCodesSetup(value) {
    this.palliativeNursingHomeVisitCodesSetup = value;
    this.checkValidForm();
    this.markDirtyAndUpdateSaveEnabled();
  }

  setPalliativeHospitalPatientVisitCodesSetup(value) {
    this.palliativeHospitalPatientVisitCodesSetup = value;
    this.checkValidForm();
    this.markDirtyAndUpdateSaveEnabled();
  }

  setPalliativeOtherBillingCodesSetup(value) {
    this.palliativeOtherBillingCodesSetup = value;
    this.checkValidForm();
    this.markDirtyAndUpdateSaveEnabled();
  }

  private markDirtyAndUpdateSaveEnabled() {
    this.hasUnsavedChanges = true;
    this.updateSaveEnabledForCodes();
  }

  private updateSaveEnabledForCodes() {
    this._saveEnabled = !!(
      this.hasUnsavedChanges &&
      this.currentContractPeriod &&
      this.validForm
    );
  }

  set saveEnabled(value: boolean) {
    this._saveEnabled = value;
  }

  get saveEnabled() {
    return this._saveEnabled;
  }

  onCollapseClicked(event, tableName) {
    switch (tableName) {
      case "palliativeHomeVisitCodes":
        this.showPalliativeHomeVisitCodes = event.isOpen;
        break;
      case "palliativeNursingHomeVisitCodes":
        this.showPalliativeNursingHomeVisitCodes = event.isOpen;
        break;
      case "palliativeHospitalPatientVisitCodes":
        this.showPalliativeHospitalPatientVisitCodes = event.isOpen;
        break;
      case "palliativeOtherBillingCodes":
        this.showPalliativeOtherBillingCodes = event.isOpen;
        break;
    }
  }

  async onContractPeriodChange(event: any) {
    if (!event) {
      this.currentContractPeriod = this.emptyContractPeriod();
      this.saveEnabled = false;
      this.previousContractPeriod = this.currentContractPeriod;
      this.clearContractPeriodCodes();
      this.showRatesSection = false;
      this.cdr.detectChanges();
      return;
    }
    if (event.value == "Add New") {
      this.addNewContractPeriod();
    } else {
      this.currentContractPeriod = {
        id: event.id,
        name: event.name,
        value: event.value,
        expiredDate: event.expiredDate,
        effectiveDate: event.effectiveDate,
      };
      this.loadCodes();
      this.previousContractPeriod = this.currentContractPeriod;
      this.hasUnsavedChanges = false;
    }
  }

  onContractPeriodClear(event: any) {
    this.contractPeriodsOptions = this.contractPeriodsOptions.filter(
      (option) => option.id != 0
    );
    this.loadOptions();
    this.currentContractPeriod = this.emptyContractPeriod();
    this.clearContractPeriodCodes();
    this.showRatesSection = false;
    this.cdr.detectChanges();
    this._saveEnabled = false;
    this.hasUnsavedChanges = false;
  }

  addNewContractPeriod() {
    let minDate: moment.Moment = moment("2023-09-30", this.dateFormat);
    this.contractPeriodsOptions.forEach((contractPeriod) => {
      let periodStart = moment(contractPeriod.effectiveDate);
      if (periodStart.isAfter(minDate)) {
        minDate = periodStart;
      }
    });

    let contractPeriodModal = this.modalCtrl.create(
      "ContractPeriodModalComponent",
      { minDateFormat: minDate },
      { cssClass: "contract-period-modal" }
    );

    contractPeriodModal.onDidDismiss((data) => {
      if (data) {
        this.hasUnsavedChanges = false;
        let newOption = this.formatContractPeriodModel(data);
        let contractPeriods = this.contractPeriodsOptions.filter(
          (contract) => contract.value != "Add New"
        );
        if (
          contractPeriods.length === 0 ||
          newOption.effectiveDate >
            this.getMostRecentContractPeriod(contractPeriods).effectiveDate
        ) {
          this.saveNewContractPeriodOption(newOption);
        } else {
          this.showAlert({
            title: "Error",
            message:
              "Contract period’s effective date can’t be before or equal to the active period’s date.",
          });
          this.onNewPeriodCanceled();
        }
      } else {
        this.onNewPeriodCanceled();
      }
    });
    contractPeriodModal.present();
  }

  onNewPeriodCanceled() {
    const hasValidPrevious =
      !!this.previousContractPeriod &&
      Array.isArray(this.contractPeriodsOptions) &&
      this.contractPeriodsOptions.some(
        (opt) =>
          opt &&
          this.previousContractPeriod &&
          (opt.value === this.previousContractPeriod.value ||
            opt.effectiveDate === this.previousContractPeriod.effectiveDate)
      );

    this.currentContractPeriod = hasValidPrevious
      ? this.previousContractPeriod
      : this.emptyContractPeriod();
    this.cdr.detectChanges();
  }

  saveNewContractPeriodOption(newOption) {
    this.contractPeriodsOptions = [newOption, ...this.contractPeriodsOptions];
    this.currentContractPeriod = newOption;
    this.clearContractPeriodCodes();
    this.removeNewContractPeriodOption();
    this.hasUnsavedChanges = false;
    this.updateSaveEnabledForCodes();
    this.showRatesSection = true;
  }

  removeNewContractPeriodOption() {
    this.contractPeriodsOptions = this.contractPeriodsOptions.filter(
      (option) => option.value != "Add New"
    );
  }

  formatContractPeriodModel(period: any): ContractPeriod {
    let newContractPeriod = moment(new Date(period)).format(this.dateUIFormat);
    let newEffectiveDate = moment(new Date(period)).format(this.dateFormat);
    return {
      id: 0,
      name: newContractPeriod,
      value: newContractPeriod,
      effectiveDate: newEffectiveDate,
      expiredDate: null,
    };
  }

  getPayerContractPeriods(firstLoad) {
    let spinnerText = "Loading Contract Periods";

    const spinner = this.loadingCtrl.create({
      content: spinnerText,
    });
    spinner.present();

    this.payersService
      .getPayerBenefitCodesPeriods(
        this.currentPayer.payerId,
        "PALLIATIVE",
        null
      )
      .pipe()
      .take(1)
      .subscribe((response) => {
        spinner.dismiss();
        let previousContractPeriods: ContractPeriod[] = [];
        if (response !== null) {
          let contractPeriod = Object.values(response);
          let count = 1;
          contractPeriod.forEach((period) => {
            let periodStart = moment(period.start);
            let name = periodStart.format(this.dateUIFormat);
            if (period.end && period.end != "") {
              name =
                name + " - " + moment(period.end).format(this.dateUIFormat);
            }
            let newPeriod = {
              id: count,
              name: name,
              value: periodStart.format(this.dateUIFormat),
              effectiveDate: periodStart.format(this.dateFormat),
              expiredDate: period.end
                ? moment(period.end).format(this.dateFormat)
                : "",
            };

            previousContractPeriods.push(newPeriod);
            count++;
          });
        }
        this.contractPeriodsOptions = previousContractPeriods.sort(
          (a, b) =>
            new Date(b.effectiveDate).getTime() -
            new Date(a.effectiveDate).getTime()
        );
        this.loadOptions();
      });
  }

  getMostRecentContractPeriod(contractPeriods) {
    return contractPeriods.sort(
      (a, b) =>
        new Date(b.effectiveDate).getTime() -
        new Date(a.effectiveDate).getTime()
    )[0];
  }

  clearContractPeriodCodes() {
    this.palliativeHomeVisitCodesSetup = this.clearPalliativeSetup(
      this.palliativeHomeVisitCodesSetup
    );
    this.palliativeNursingHomeVisitCodesSetup = this.clearPalliativeSetup(
      this.palliativeNursingHomeVisitCodesSetup
    );
    this.palliativeHospitalPatientVisitCodesSetup = this.clearPalliativeSetup(
      this.palliativeHospitalPatientVisitCodesSetup
    );
    this.palliativeOtherBillingCodesSetup = this.clearPalliativeSetup(
      this.palliativeOtherBillingCodesSetup
    );
    this.hasUnsavedChanges = false;
  }

  clearPalliativeSetup(codesArray) {
    const isMedicare =
      this.currentPayer &&
      this.currentPayer.payerType &&
      this.currentPayer.payerType.toUpperCase() === "MEDICARE";

    codesArray.map((code) => {
      code.M1 = "";
      code.M2 = "";
      code.M3 = "";
      code.M4 = "";
      code.Error = "";
      code.Disabled = false; //isMedicare;
      return code;
    });
    return codesArray;
  }

  mapContractPeriodCodes(codesData) {
    const isMedicare =
      this.currentPayer &&
      this.currentPayer.payerType &&
      this.currentPayer.payerType.toUpperCase() === "MEDICARE";

    const forEachMap = (item) => {
      const match = Object.values(codesData[0].codes).find(
        (codeObj) => codeObj["service"] === item.Service
      );
      if (match) {
        item.M1 = match["m1"];
        item.M2 = match["m2"];
        item.M3 = match["m3"];
        item.M4 = match["m4"];
        item.Error = "";
        item.Disabled = false; //isMedicare;
      }
    };

    if (
      codesData &&
      codesData.length > 0 &&
      Object.keys(codesData[0].codes).length > 0
    ) {
      this.palliativeHomeVisitCodesSetup.forEach(forEachMap);
      this.palliativeNursingHomeVisitCodesSetup.forEach(forEachMap);
      this.palliativeHospitalPatientVisitCodesSetup.forEach(forEachMap);
      this.palliativeOtherBillingCodesSetup.forEach(forEachMap);
    }
  }

  formatToTwoDecimals(num: number): string {
    return num.toFixed(2);
  }

  saveNewPayerContractPeriod(
    palliativeVisitCodesData: PalliativeVisitCodes,
    saveMessage: string,
    saveCode: boolean
  ) {
    if (this.currentPayer) {
      let spinnerText = "Saving Palliative Visit...";

      const spinner = this.loadingCtrl.create({
        content: spinnerText,
      });
      spinner.present();
      this.payersService
        .postPayerBenefitCodes(palliativeVisitCodesData)
        .pipe()
        .take(1)
        .subscribe(
          () => {
            spinner.dismiss();
            this.contractPeriodsOptions = [];
            this.getPayerContractPeriods(false);
            this.onSaveSuccessAlert(saveMessage);
            this.loadOptions();
            this.previousContractPeriod = this.currentContractPeriod;
            if (saveCode) {
              this.setCheckMark.emit();
            }
          },
          (error) => {
            spinner.dismiss();
            this.showError(error);
          }
        );
    } else {
      this.currentContractPeriod = this.emptyContractPeriod();
      this.contractPeriodsOptions = [];
      this.loadOptions();
      this.showAlert({
        title: "Error",
        message:
          "Payer general information needs to be saved before adding a new contract period.",
      });
    }
  }

  showError = (error) => {
    if (error instanceof HttpErrorResponse) {
      if (error.error) {
        this.showAlert({
          title: "Error",
          message: "Error while saving codes: " + error.error,
        });
      } else {
        this.showAlert({
          title: "Error",
          message: "Error while saving codes: " + error.message,
        });
      }
    }
  };

  showAlert = ({ title, message }) => {
    let alert = this.alertCtrl.create({
      title,
      message,
      buttons: [
        {
          text: "Ok",
          handler: () => {},
        },
      ],
    });
    alert.present();
  };

  mapNewPalliativeVisitCode(codes, start, end) {
    let newVisitCodes: PalliativeVisitCodes = {
      payerId: this.currentPayer ? this.currentPayer.payerId : null,
      benefitType: "PALLIATIVE",
      benefitSubtype: null,
      payerType: this.currentPayer
        ? this.currentPayer.payerType.toUpperCase()
        : null,
      codes: codes,
      start: start,
      end: end,
    };
    return newVisitCodes;
  }

  private onSaveSuccessAlert = (message: string) => {
    this.showAlert({
      title: "Success",
      message: message,
    });

    this.hasUnsavedChanges = false;
    this._saveEnabled = false;
  };

  getEffectiveDate() {
    return this.currentContractPeriod &&
      this.currentContractPeriod.effectiveDate
      ? this.formatDate(this.currentContractPeriod.effectiveDate)
      : "";
  }

  getExpiredDate() {
    return this.currentContractPeriod && this.currentContractPeriod.expiredDate
      ? this.formatDate(this.currentContractPeriod.expiredDate)
      : "";
  }

  formatDate(dateString: string): string {
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);

    const formattedMonth = (date.getMonth() + 1).toString().padStart(2, "0");
    const formattedDay = date.getDate().toString().padStart(2, "0");
    const formattedYear = date.getFullYear();

    return `${formattedMonth}/${formattedDay}/${formattedYear}`;
  }

  showSavePayerModal() {
    if (this.currentContractPeriod && this.currentContractPeriod.id > 0) {
      let modalPage = this.modalCtrl.create(
        "SaveFacilityPage",
        {
          title: "Payer Information Change",
          commentPlaceholderKey: "archiveFacilityCommentPlaceHolder",
          popupMessageKey: "savePayerWarningMessage",
          section: "payer",
        },
        {
          enableBackdropDismiss: false,
          cssClass: "save-payer-confirmation-popup",
        }
      );
      modalPage.onDidDismiss((data) => {
        if (data.save) {
          this.saveVisitCodes();
        }
      });
      modalPage.present();
    } else {
      this.saveVisitCodes();
    }
  }

  loadCodes(): void {
    if (this.currentContractPeriod) {
      let spinnerText = "Loading Codes...";

      const spinner = this.loadingCtrl.create({
        content: spinnerText,
      });
      spinner.present();

      this.payersService
        .getPayerBenefitCodesByPeriod(
          this.currentPayer.payerId,
          "PALLIATIVE",
          null,
          this.currentContractPeriod.effectiveDate
        )
        .pipe()
        .take(1)
        .subscribe(
          (response) => {
            spinner.dismiss();
            this.clearContractPeriodCodes();
            this.mapContractPeriodCodes(response);
            this.hasUnsavedChanges = false;
            this.updateSaveEnabledForCodes();
          },
          (error) => {
            spinner.dismiss();
            this.clearContractPeriodCodes();
            this.hasUnsavedChanges = false;
            this.updateSaveEnabledForCodes();
            this.showError(error);
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/payers/billing-codes/palliative-visits/palliative-visits.ts